import { TreeSelect, TreeSelectProps } from 'antd'
import { useTranslation } from 'react-i18next'
import React, { useMemo } from 'react'
import { useCustomReportStructure } from '../../queries/structure/useCustomReportStructure'
import { generateTreeData } from '../../utils'
import './CustomReportTreeSelect.css'

interface CustomReportTreeSelectProps extends TreeSelectProps {
  companyId: string
}

const CustomReportTreeSelect = ({ companyId, ...props }: CustomReportTreeSelectProps) => {
  const { i18n } = useTranslation()
  const { data: customReportTree, isLoading, isPending } = useCustomReportStructure(companyId)
  const treeData = useMemo(
    () => (customReportTree ? generateTreeData(customReportTree) : []),
    [customReportTree, i18n.language]
  )

  return (
    <TreeSelect
      treeIcon
      treeLine
      treeDefaultExpandAll
      showSearch
      disabled={isPending}
      treeData={treeData}
      loading={isLoading}
      filterTreeNode={(inputval, node) => {
        if (!node || !inputval) return false
        return String(node.title || '')
          .toLowerCase()
          .includes(inputval.toLowerCase())
      }}
      style={{ width: 300 }}
      popupMatchSelectWidth={false}
      classNames={{ popup: { root: 'custom-report-tree-popup' } }}
      styles={{ popup: { root: { maxWidth: 500 } } }}
      {...props}
    />
  )
}

export default CustomReportTreeSelect
